<template>
  <div class="h-toolbarBg">
    <div>
      <div class="col-lg-12 ">
        <div id='content' class="width-135">
          <ejs-dropdownlist id='games' :dataSource='data' :fields='fields' popupHeight='auto' :placeholder='waterMark' :change='changeFunc'></ejs-dropdownlist>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MonitObserveTableMenu',
  data() {
    return {
      waterMark: this.$t('Observe.pleaseSelect'),
      height: '220px',
      fields: {
        text: 'Text',
        value: 'Value',
        isChecked: 'Selected'
      },
      data: [
        { Text: this.$t('Observe.all'), Value: '0' },
        { Text: this.$t('Observe.activation'), Value: '1' },
        { Text: this.$t('Observe.hangup'), Value: '2' }
      ],
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  methods: {
    changeFunc(args) {
      this.$emit('methodEnum', args);
    }
  }
};
</script>
